/* eslint-disable import/prefer-default-export */
import FolderSearchIcon from "../../assets/logos/FolderSearchIcon.svg";
import Applications from "../../assets/logos/Applications.svg";
import RevenueLoss from "../../assets/logos/RevenueLoss.svg";
import Trendup from "../../assets/logos/Trendup.svg";

export const intakeData = {
  agentName: "Intake Review Agent",
  pageTitle: "Intake Review Agent",
  title: "Intake Review Agent",
  subtitle: "Agentic Apps",

  entries: [
    {
      icon: "IR",
      text: 'You have been <strong>assigned 9 applications</strong>.',
      meta: "2 hr ago",
      badge: "For Intake Review",
      links: [
        { label: "Ask Intake review Agent", href: "#open", type: "openAgent" },
        { label: "View Application", href: "#details" },
      ],
    },
    {
      icon: "IR",
      text: 'You have been <strong>assigned case #3090</strong>.',
      meta: "4 hr ago",
      badge: "For Intake Review",
      links: [
        { label: "Ask Intake review Agent", href: "#open", type: "openAgent" },
        { label: "View Application", href: "#details" },
      ],
    },
  ],

 actionItems: [
    {
      text: "Applications for Intake Review",
      type: "red",
      link: "#",
      linkText: "Assigned from Canopy",
      number: "10",
    },
    // {
    //   text: "Duplication review",
    //   type: "red",
    //   link: "#",
    //   number: "16",
    // },
    // { text: "Report Generation", type: "normal", number: "0" },
  ],

  stats: [
    {
      title: "Potential Duplicates as of Today",
      value: "16",
      label: "+8% detection accuracy from last week",
      hint: "match (avg. 86% confidence)",
      icon: FolderSearchIcon,
      labelIcon: Trendup,
    },
    {
      title: "Applications Reviewed as of Today",
      value: "48",
      label: "+4 applications per day from last week",
      hint: "/day",
      icon: Applications,
      labelIcon: Trendup,
    },
    {
      title: "Applications Processing Rate",
      value: "35s",
      label: "Down 3 seconds from last week",
      hint: "/applications",
      icon: RevenueLoss,
      labelIcon: Trendup,
    },
    {
      title: "Applications Reviewed as of Today",
      value: "48",
      label: "+4 applications per day from last week",
      hint: "/day",
      icon: FolderSearchIcon,
      labelIcon: Trendup,
    },
  ],
};
